module.exports = __webpack_public_path__ + "static/freshdesk-c16d2723bae7fdbe7ed0917dd8522d54.svg";